import { SerializedError } from "@reduxjs/toolkit";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";
import { DateTime } from "luxon";

import { VideoRetrievalService } from "@/api/services/interfaces";
import { lvtResponseVideoRetrievalValidator } from "@/api/validation/videoRetrieval";
import { logError } from "@/utilities/api";

import { routes } from "../routes";


axios.defaults.withCredentials = true;

const client = applyCaseMiddleware(axios.create());

export const videoRetrievalService: VideoRetrievalService = {
    async requestVideoRetrieval(
        cameraId: number,
        title: string,
        startTime: DateTime,
        endTime: DateTime,
    ): Promise<void | Error> {
        const route = routes.retrieveVideo(cameraId);

        try {
            const response = await client.post(route, {
                title,
                start: startTime.toUTC().toISO(),
                stop: endTime.toUTC().toISO(),
            });

            if (lvtResponseVideoRetrievalValidator(response.data)) {
                return;
            } else {
                const error: SerializedError = {
                    name: "validation",
                    message: JSON.stringify(lvtResponseVideoRetrievalValidator.errors),
                };

                return error as Error;
            }
        } catch (error) {
            logError(route, error as Error);

            return (error as Error);
        }
    },
};

export const dummyVideoRetrievalService: VideoRetrievalService = {
    async requestVideoRetrieval(
        cameraId: number,
        title: string,
        startTime: DateTime,
        endTime: DateTime,
    ): Promise<void | Error> {
        const error = {
            name: "dummy",
            message: `Using the dummy service for cameraId: ${cameraId}, with title: ${title}, starttime: ${startTime} and endtime: ${endTime}`,
        };

        return error;
    },
};
